import type { NavigateFunction } from "react-router-dom";
import { fetchCategoryDetails } from "@/apis";
import { normalizePostType } from "@/utility";
import type { DashboardAction, DashboardProfile, DialogName, SideDrawerName } from "./types";

const getCategory = (response: any) => {
  const data = response?.data?.response ?? response?.data;
  return Array.isArray(data) ? data[0] : data;
};

const PROPERTY_CATEGORY_ID = "8";

const getSellCategoryId = (profile: DashboardProfile) => {
  const accessName = profile.accessName.trim().toLowerCase();
  const isPropertyCustomer = accessName === "customer" || accessName === "investor";
  const isSyntheticDashboardCategory = ["-1", "-5", "999"].includes(profile.categoryId);
  return isPropertyCustomer || isSyntheticDashboardCategory
    ? PROPERTY_CATEGORY_ID
    : profile.categoryId;
};

const createListing = async (profile: DashboardProfile, navigate: NavigateFunction) => {
  try {
    const categoryId = getSellCategoryId(profile);
    const response = await fetchCategoryDetails(categoryId);
    const categoryKey = getCategory(response)?.key ?? "";
    if (!categoryKey) return;

    const search = new URLSearchParams({
      postType: normalizePostType(profile.accessName),
    });
    if (profile.userPlanId) search.set("userPlanId", profile.userPlanId);
    navigate(`/sell/${categoryKey}?${search.toString()}`);
  } catch {
    // Keep the user on the dashboard when the category cannot be resolved.
  }
};

export const executeDashboardAction = (
  action: DashboardAction,
  profile: DashboardProfile,
  navigate: NavigateFunction,
  openDialog: (name: DialogName | SideDrawerName) => void,
) => {
  if (action.type === 'none') return;
  if (action.type === 'link') window.open(action.to, "_blank", "noopener,noreferrer");;
  if (action.type === "route") navigate(action.to);
  if (action.type === "dialog") openDialog(action.name);
  if (action.type === "drawer") openDialog(action.name);
  if (action.type === "create-listing") createListing(profile, navigate);
  //any custom action write here
};
